if(!customElements.get('slider-custom')) {
  class ComponentSlider extends HTMLElement {
    constructor() {
      super();
      this.knobContainer = this.querySelector(".knob-container");
      this.knob = this.querySelector(".knob-custom");
      this.progress = this.querySelector(".progress-bar-custom");
      this.currentPos = 50;
      this.savingNewPos = 0;
      this.setNewPos(this.currentPos);

      var lastPos;
      var selected = false;

      this.knob.addEventListener('keydown', (e) => {
        switch (e.key) {
          case "ArrowLeft":
            this.setNewPos(this.calcNewPos(-10));
            this.finishMove();
            break;
          case "ArrowRight":
            this.setNewPos(this.calcNewPos(10));
            this.finishMove();
            break;
        }
      });

      this.knob.addEventListener('mousedown', (e) => {
        lastPos = e.clientX;
        selected = true;
      });

      document.addEventListener('mousemove', (e) => {
        if(selected){
          var movePos = e.clientX;
          var deltaX = movePos - lastPos;
          this.setNewPos(this.calcNewPos(deltaX));
        }
      });

      document.addEventListener('mouseup', (e) => {
        if(selected){
         selected = false;
         this.finishMove();
        }
      });

      var touchId;

      this.knob.addEventListener('touchstart', (e) => {
        selected = true;
        var touch = e.targetTouches[0];
        lastPos = touch.clientX;
        touchId = touch.identifier;
      });

      document.addEventListener('touchend', (e) => {
        if(selected){
          selected = false;
          this.finishMove();
         }
      });

      document.addEventListener('touchmove', (e) => {
        if(selected){
          var touches = e.changedTouches;

          for (let i = 0; i < touches.length; i++) {
            if(touches[i].identifier == touchId)
            {
              var movePos = touches[i].clientX;
              var deltaX = movePos - lastPos;
              this.setNewPos(this.calcNewPos(deltaX));
            }
          }
         }
      });

    }

    calcNewPos(deltaX){
      var percentMovement = deltaX * 100 / this.knobContainer.offsetWidth;
      var newPos = this.currentPos + percentMovement
      newPos = Math.min(100, Math.max(0, newPos));
      return newPos;
    }

    setNewPos(newPos){
      this.knob.style.left = newPos + "%";
      this.progress.style.width = newPos + "%";
      this.savingNewPos = newPos;

      const cEvent = new CustomEvent('slider', { bubbles: true, detail: newPos });
      this.dispatchEvent(cEvent);
    }

    finishMove(){
      this.currentPos = this.savingNewPos;
    }
    
  }
  customElements.define('slider-custom', ComponentSlider);
}

